import { generateOptionsFromData, getBaseURL, getFormattedDate, sendAPIRequest } from "helpers";
import ComponentLoader from "pages/components/ComponentLoader";
import React, { useMemo } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PowerBISingle from "./PowerBISingle";
import { USER_ROLES } from "constants";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import CustomCard from "components/common/CustomCard";
import CardHeader from "components/common/CardHeader";
import CardBody from "components/common/CardBody";
import Row from "components/common/Row";
import Column from "components/common/Column";
const PowerBiListComponent = (props) => {

  const { roleId } = useParams();
  const authData = useSelector((s) => s.auth.data);
  const siteLanguage = useSelector((s) => s.general.siteLanguage);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [dashboardName, setDashboardname] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingTags, setLoadingTags] = useState(false);
  const [dashboardId, setDashboardId] = useState("");
  const [url, setUrl] = useState("/portal/qualitative-dashboard");
  const { t } = useTranslation();
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedDashboardNames, setselectedDashboardNames] = useState([]);

  const [params, setParams] = useSearchParams();

  const groupid = params.get('group_id');
  const roleid = params.get('role_id');

  const colors = [
    { border: "#DDEAF4", background: "#DDEAF4", text: "#208CD0" },
    { border: "#FEF3CF", background: "#FEF3CF", text: "#CF9228" },
    { border: "#DDF4C7", background: "#DDF4C7", text: "#68847c" },
    { border: "#ffe0d7", background: "#ffe0d7", text: "#ff4500" },
    { border: "#e6d7ff", background: "#e6d7ff", text: "#9370db" }
  ]

  useEffect(() => {
    getDashboardData();
  }, [siteLanguage, selectedTags, selectedDashboardNames]);

  useEffect(() => {
    getDashboardName();
    getTags();
  }, []);

  const getTags = async () => {
    setLoadingTags(true);
    try {
      const ret = await sendAPIRequest(`/api/dashboard-tags`);
      const res = await ret.json();
      if (res.success && res.status === 200) {
        setTags(res.data);
      }
    } catch (err) {
      console.error(err);
      setLoadingTags(false);
    }
    setLoadingTags(false);
  }

  const getDashboardData = async () => {
    try {
      setIsLoading(true);
      const tagsParams = selectedTags.join(',');
      const dashboardNames = selectedDashboardNames.join(',')
      if (props.home) {
        const req = await sendAPIRequest(
          `/api/dashboards/home-dashboard?page=home&tags=${tagsParams}&dashboards=${dashboardNames}`
        );
        const res = await req.json();
        setUrl("/analytics");
        if (res.success) {
          setData(res.data);
        } else {
          setData([]);
        }
      }
      if (authData && authData.id && (USER_ROLES.business_admin.includes(parseInt(authData.role_id) || groupid))) {
        const req = await sendAPIRequest(
          groupid
            ? `/api/dashboards/userdashboard?user_id=${authData.id}&group_id=${groupid}&page=insights&tags=${tagsParams}&dashboards=${dashboardNames}`
            : `/api/dashboards/userdashboard?user_id=${authData.id}&role_id=${roleid}&page=insights&tags=${tagsParams}&dashboards=${dashboardNames}`
        );
        const res = await req.json();
        if (res.success) {
          setData(res.data);
        } else {
          setData([]);
        }
      }
      if (authData && authData.id && !USER_ROLES.business_admin.includes(parseInt(authData.role_id))) {
        const req = await sendAPIRequest(
          `/api/dashboards/userdashboard?user_id=${authData.id}&page=insights&tags=${tagsParams}&dashboards=${dashboardNames}`
        );
        const res = await req.json();
        if (res.success) {
          setData(res.data);
        } else {
          setData([]);
        }
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };


  const getDashboardName = async () => {
    try {
      setIsLoading(true);
      const tagsParams = selectedTags.join(',');
      let response;

      if (props.home) {
        response = await sendAPIRequest(
          `/api/dashboards/home-dashboard?page=home&tags=${tagsParams}`
        );
      } else if (
        authData &&
        authData.id &&
        USER_ROLES.business_admin.includes(parseInt(authData.role_id))
      ) {
        const url = groupid
          ? `/api/dashboards/userdashboard?user_id=${authData.id}&group_id=${groupid}&page=insights&tags=${tagsParams}`
          : `/api/dashboards/userdashboard?user_id=${authData.id}&role_id=${roleid}&page=insights&tags=${tagsParams}`;

        response = await sendAPIRequest(url);
      } else if (authData && authData.id) {
        response = await sendAPIRequest(
          `/api/dashboards/userdashboard?user_id=${authData.id}&page=insights&tags=${tagsParams}`
        );
      }

      if (response) {
        const res = await response.json();
        setDashboardname(res.success ? res.data : []);
        if (props.home) setUrl("/analytics");
      } else {
        setDashboardname([]);
      }
    } catch (e) {
      console.log(e);
      setDashboardname([]);
    } finally {
      setIsLoading(false);
    }
  };

  const IRS = () => {
    navigate("/portal/IRS");
  };

  const goBack = () => {
    navigate(-1);
  };

  const tagOptions = useMemo(() => {
    return generateOptionsFromData(tags, {
      value: "id",
      label: "tag_name",
    });
  }, [tags]);

  const dashboardNameOptions = useMemo(() => {
    const hasGroupOrRole = groupid || roleid;
    const data = hasGroupOrRole
      ? dashboardName.map((item) => item?.dashboard)
      : dashboardName;

    return generateOptionsFromData(data, {
      value: "id",
      label: "dashboard_name",
    });
  }, [dashboardName, groupid, roleid]);

  console.log("selectedDashboardNames", selectedDashboardNames)
  const TagsFilters = () => {
    return (
      <CustomCard>
        <CardHeader>
          <div className="card-title my-0">{t("14", "Filters")}</div>
        </CardHeader>
        <CardBody>
          <Row>
            <Column col={6}>
              <AutoCompleteDropdown
                required={false}
                error={false}
                label={t("-1", "Tags")}
                multiple={true}
                hasselectall={true}
                options={tagOptions}
                onChange={(event, value) => {
                  if (value.some((v) => v.value == "Select all")) {
                    if (selectedTags.length == tagOptions.length) {
                      // Deselect all options
                      setSelectedTags([]);
                    } else {
                      // Select all options
                      setSelectedTags(tagOptions.map((r) => r.value));
                    }
                  } else {
                    setSelectedTags(value.map((r) => r.value));
                  }
                }}
                value={selectedTags}
              />
            </Column>
            <Column col={6}>
              <AutoCompleteDropdown
                required={false}
                error={false}
                label={t("-1", "Dashboard Name")}
                multiple={true}
                hasselectall={true}
                options={dashboardNameOptions}
                onChange={(event, value) => {
                  if (value.some((v) => v.value == "Select all")) {
                    if (selectedDashboardNames.length == dashboardNameOptions.length) {
                      // Deselect all options
                      setselectedDashboardNames([]);
                    } else {
                      // Select all options
                      setselectedDashboardNames(dashboardNameOptions.map((r) => r.value));
                    }
                  } else {
                    setselectedDashboardNames(value.map((r) => r.value));
                  }
                }}
                value={selectedDashboardNames}
              />
            </Column>
          </Row>
        </CardBody>
      </CustomCard>
    )
  }

  return (
    <>
      {
        USER_ROLES.business_admin.includes(parseInt(authData.role_id)) ? (
          <>
            <div className="container my-4">
              <div className="">
                <div className="row">
                  <div className="col-md-12">
                    <div className="caption">
                      <div className="card-title-1 mb-1 fs-b lh-1">
                        {t("1091", "PVS Pathway Insights")}
                      </div>
                      <div className="paragraph text-justify">
                        <p className="fs-5 text-justify">
                          {t(
                            "1050",
                            "The data and insights developed throughout the PVS Pathway enable countries to take ownership and prioritise improvements to their animal health systems."
                          )}{" "}
                          {t(
                            "1051",
                            "They can use these findings to advocate for additional investment and sustainable funding, both from their governments and international or bilateral donors, to support more resource-intensive investments."
                          )}
                        </p>
                      </div>
                      <div className="paragraph text-justify">
                        <p className="fs-5 text-justify">
                          {t(
                            "1052",
                            "All PVS Evaluation and Follow-up missions follow the same methodological approach: independent experts systematically evaluate 45 Critical Competencies (CCs) listed in the"
                          )}
                          <a href="https://doc.woah.org/dyn/portal/digidoc.xhtml?statelessToken=7pMNb_8Wg7sIFj0T6_gXDyrRS1LECKhJo6skzvBeGIY=&actionMethod=dyn%2Fportal%2Fdigidoc.xhtml%3AdownloadAttachment.openStateless" target="_blank" rel="noopener noreferrer">

                            {" "}
                            {t("1053", "PVS Tool - Terrestrial")}
                          </a>{" "}
                          {t("1054", "and the 47 CCs listed in the")}
                          <a
                            href="https://www.woah.org/en/document/pvs-aquatic-tool-2021/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            {t("1055", "PVS Tool – Aquatic")}
                          </a>{" "}
                          {t(
                            "1056",
                            "via documentation, interviews and observation."
                          )}{" "}
                          {t(
                            "1057",
                            "The findings are endorsed by the country and made available depending on the country’s preference."
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p className="fs-5 text-justify">
                {t(
                  "3273",
                  "The dashboard text is under translation at present and will be added to the dashboards as it is validated.  Please excuse us for any delay, and remember to check back often to check for improvements and additional translations that will be made on a weekly basis over the coming weeks."
                )}
              </p>
              <h1 class="text-dark fw-bold p-0">{t("3274", "Qualitative Insights")}</h1>
              <p className="fs-5 text-justify">
                {t(
                  "3271",
                  "In order to leverage historical data for trend analysis and data driven decision making, Members can discover and explore the recommendations of the PVS Pathway in a new light. WOAH’s model extracts all text from each Critical Competency chapter of Part III of each PVS Evaluation-type Report, summarises it and the creates key recommendations for descriptive analysis of the most common recommendations made."
                )}
              </p>
              <p className="fs-5 text-justify">
                {t(
                  "3272",
                  "While we strive to provide accurate and meaningful insights in our Qualitative Analysis.  The model is under continuous development to improve its outputs for your use and improvements will be made on a weekly basis over the coming months.  Currently only one-to-one relationships are possible between raw text and key concepts.  As the technology develops, additional one-to-many relationships may become posssible.  Our model intends to facilitate exploration and keep PVS data relevant.  We encourage users to interpret results with discernment and utilise their experience to mediate the analysis. We believe in the value of human judgment and perspective in qualitative analysis, and our dashboards should be viewed as a supportive tool rather than a definitive or singular interpretation."
                )}
              </p>
              <div className="border-bottom border-2 border-dark  fs-5 py-2">
                <p className="fs-5 text-justify">
                  {t("3210", "To view the")}{" "}
                  <span className="fw-bold">{t("3211", "indicator matrix")}</span>{" "}
                  , {t("3212", "please")}{" "}
                  <span className="text-primary cursor-pointer" onClick={IRS}>
                    {t("3213", "click here")}
                  </span>{" "}
                </p>
              </div>
              <TagsFilters />
              <br />
              <div className="header card-woah border border-secondary d-flex px-4 py-2 pt-2 shadow-sm w-100">
                <div className="d-flex justify-content-between">
                  <div className="card-title1 lh-1">
                    {
                      params.get("role_name")
                        ? params.get("role_name")
                        : t("-1", "Dashboards")
                    }
                  </div>
                </div>
                <div className="header-right-items ms-auto d-flex align-items-center">
                  <div className="ms-auto">
                    <button
                      onClick={goBack}
                      className="btn btn--primary fs-7 lh-1"
                    >
                      {" "}
                      <i className="fas fa-angle-left text-white" />
                      {t("32", "Back")}
                    </button>
                  </div>
                </div>
              </div>
              <div className="border-bottom border-2 border-dark pb-5 mb-5">
                {
                  props.header(props.openDashboardInside && dashboardId, () =>
                    setDashboardId("")
                  )
                }
                {
                  (authData.id && data?.length > 0) || props.home ? (
                    <div className="row my-5 py-1">
                      {
                        props.openDashboardInside && dashboardId ? (
                          <PowerBISingle
                            dashboardId={dashboardId}
                            showHeader={false}
                          />
                        ) : (
                          data?.map(function (item, key) {
                            return (
                              <div className=" col-md-4 col-12 p-3" key={item.id}>
                                <div
                                  className="courses shadow rounded-0 h-100"
                                  style={{
                                    border: "1px solid #ffe0d7",
                                  }}
                                >
                                  <div
                                    className=" cursor-pointer p-5"
                                    onClick={() => {
                                      if (props.openDashboardInside) {
                                        setDashboardId(item.dashboard_id);
                                      } else {
                                        navigate(
                                          `${url}/${item.dashboard_id
                                          }?dashboard_name=${encodeURIComponent(
                                            item?.dashboard?.dashboard_name
                                          )}`
                                        );
                                      }
                                    }}
                                  >
                                    <h1 className="text-primary  text-center fw-bold p-0">
                                      {item?.dashboard?.dashboard_name}
                                    </h1>
                                    <p className="p-5 fs-5 text-justify text-left">
                                      {item?.dashboard?.description}
                                    </p>
                                    <div className="d-flex flex-wrap justify-content-center">{item?.dashboard?.dashboard_tag_mappings?.map((mapping, index) => {
                                      const color = colors[index % colors.length];
                                      return (<div
                                        key={index}
                                        className="fs-5 px-3 py-1 mr-2 mb-2 rounded-4"
                                        style={{
                                          border: `3px solid ${color.border}`,
                                          backgroundColor: color.background,
                                          color: color.text,
                                          marginLeft: '8px',
                                        }}
                                      >
                                        {mapping?.dashboard_tag?.tag_name}
                                      </div>)
                                    }
                                    )
                                    }
                                    </div>
                                    {
                                      item?.dashboard?.updatedAt &&
                                      <div className="d-flex justify-content-center mt-2">
                                        <div>
                                          Last updated on:
                                        </div>
                                        <p className="ps-2 text-primary fw-bold ">
                                          {
                                            getFormattedDate(item?.dashboard?.updatedAt, true)
                                          }
                                        </p>
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )
                      }
                    </div>
                  ) : (
                    <ComponentLoader />
                  )}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="container my-10">
              <div className="border-bottom border-2 border-dark pb-5 mb-5">
                <TagsFilters />
                {props.header(props.openDashboardInside && dashboardId, () =>
                  setDashboardId("")
                )}
                {(authData.id && data?.length > 0) || props.home ? (
                  <div className="row my-5 py-1">
                    {props.openDashboardInside && dashboardId ? (
                      <PowerBISingle
                        dashboardId={dashboardId}
                        showHeader={false}
                      />
                    ) : (
                      data?.map(function (item, key) {
                        return (
                          <div className=" col-md-4 col-12 p-3" key={item.id}>
                            <div
                              className="courses shadow rounded-0 h-100"
                              style={{
                                border: "1px solid #ffe0d7",
                              }}
                            >
                              <div
                                className=" cursor-pointer p-5"
                                onClick={() => {
                                  if (props.openDashboardInside) {
                                    setDashboardId(item.id);
                                  } else {
                                    navigate(
                                      `${url}/${item.id
                                      }?dashboard_name=${encodeURIComponent(
                                        item?.dashboard_name
                                      )}`
                                    );
                                  }
                                }}
                              >
                                <h1 className="text-primary text-center fw-bold p-0">
                                  {item?.dashboard_name}
                                </h1>
                                <p className="p-5 fs-5 text-justify text-left">
                                  {item?.description}
                                </p>
                                <div className="d-flex flex-wrap justify-content-center">{item?.dashboard_tag_mappings?.map((mapping, index) => {
                                  const color = colors[index % colors.length];
                                  return (
                                    <div
                                      key={index}
                                      className="fs-5 px-3 py-1 mr-2 mb-2 rounded-4"
                                      style={{
                                        border: `3px solid ${color.border}`,
                                        backgroundColor: color.background,
                                        color: color.text,
                                        marginLeft: '8px',
                                      }}
                                    >
                                      {mapping?.dashboard_tag?.tag_name}
                                    </div>
                                  )
                                })
                                }
                                </div>
                                {
                                  item?.updatedAt &&
                                  <div className="d-flex justify-content-center mt-2">
                                    <div>
                                      Last updated on:
                                    </div>
                                    <p className="ps-2 text-primary fw-bold ">
                                      {
                                        getFormattedDate(item?.updatedAt, true)
                                      }
                                    </p>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )
                    }
                  </div>
                ) : (
                  <ComponentLoader />
                )}
              </div>
            </div>
          </>
        )
      }
    </>
  );

};

PowerBiListComponent.defaultProps = {
  openDashboardInside: false,
  header: () => { },
  home: false,
};

export default PowerBiListComponent;
